<template>
  <div class="pega-interviewer-wrap">
    <span
      class="boss-bgcolor-white-gray pega-selection-label"
      data-test="selection-no-label"
    >{{ index }}次選考</span>
    <!-- ▼☓ボタン -->
    <button
      class="boss-close-button boss-icon-cross pega-interviewer-cross"
      type="button"
      data-test="cancel"
      @click="$emit('delete')"
    />
    <!-- ▲☓ボタン -->
    <div class="grid-x  grid-margin-x  pega-mt-1">
      <div class="margin-left-1">
        <span>入力方法</span>
      </div>
      <div class="margin-left-2">
        <label
          v-for="(way ,i) in interviewOptions.inputWays"
          :key="i"
          class="pega-input pega-radio-inline margin-right-1"
        >
          <input
            :data-test="`way-${i}`"
            :value="way.id"
            :checked="selectionTypeId === way.id"
            type="radio"
            class="boss-input-checkbox"
            @change="$emit('update:selectionType', $event.target._value)"
          >
          <span
            :data-test="`way-label-${i}`"
          >{{ way.name }}</span>
        </label>
        <validation-label
          v-if="requiredSelectionType.isShow"
          data-test="input-type-error-required"
          :label="requiredSelectionType.message"
        />
      </div>
    </div>
    <!-- 入力方法がフリー項目の時は表示しない -->
    <div v-if="!isFreeInput">
      <interviewer-radio-form
        :value="interviewer.gender.id"
        label="性別"
        :options="interviewOptions.genders"
        data-test="gender"
        @input="$emit('update:gender', $event)"
      >
        <template #error>
          <validation-label
            v-if="requiredRadioSelection(interviewer.gender.id).isShow"
            data-test="gender-error-required"
            :label="requiredRadioSelection(interviewer.gender.id).message"
          />
        </template>
      </interviewer-radio-form>
      <interviewer-radio-form
        :value="interviewer.position.id"
        label="部署"
        :options="interviewOptions.positions"
        @input="$emit('update:position', $event)"
      >
        <template #error>
          <validation-label
            v-if="requiredRadioSelection(interviewer.position.id).isShow"
            data-test="position-error-required"
            :label="requiredRadioSelection(interviewer.position.id).message"
          />
        </template>
      </interviewer-radio-form>
      <interviewer-radio-form
        :value="interviewer.generation.id"
        label="年代"
        :options="interviewOptions.generations"
        @input="$emit('update:generation', $event)"
      >
        <template #error>
          <validation-label
            v-if="requiredRadioSelection(interviewer.generation.id).isShow"
            data-test="generation-error-required"
            :label="requiredRadioSelection(interviewer.generation.id).message"
          />
        </template>
      </interviewer-radio-form>
    </div>
    <div class="pega-mt-05">
      <span data-test="remarks-freetext-label">{{ remarksLabel }}<small :class="{'pega-ml-1' : !isFreeInput}">{{ interviewer.remarksOrFreeText? interviewer.remarksOrFreeText.length : 0 }}文字/ 1000文字</small></span>
    </div>
    <div>
      <textarea
        ref="component"
        :value="interviewer.remarksOrFreeText"
        :placeholder="`（例）配属先チームの責任者が担当します。\n仕事内容や研修についてなど、気軽にご相談下さい。`"
        class="pega-form-item pega-interview-textarea-large pega-textarea-vertical"
        data-test="item"
        @input="$emit('update:remarksOrFreeText', $event.target.value)"
      />
      <validation-label
        v-if="requiredInputFreeText.isShow"
        data-test="free-text-error-required"
        :label="requiredInputFreeText.message"
      />
      <validation-label
        v-if="overLengthFreeText.isShow"
        data-test="free-text-over-length"
        :label="overLengthFreeText.message"
      />
    </div>
  </div>
</template>

<script>
import { jobInterview } from '@/lib/labelValueMappings'
import InterviewerRadioForm from '@/components/atoms/InterviewerRadioForm.vue'
import ValidationLabel from '@/components/atoms/ValidationLabel'

export default {
  components: {
    InterviewerRadioForm,
    ValidationLabel
  },
  props: {
    interviewer: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      interviewOptions: jobInterview
    }
  },
  computed: {
    selectionTypeId () {
      return this.interviewer.selectionType.id
    },
    remarksLabel () {
      return this.selectionTypeId === 2 ? '' : '備考'
    },
    isFreeInput () {
      return this.selectionTypeId === 2
    },
    requiredSelectionType () {
      return {
        isShow: this.selectionTypeId === 0,
        message: '選択してください'
      }
    },
    requiredRadioSelection () {
      return (val) => {
        return {
          isShow: this.selectionTypeId === 1 && val === 0,
          message: '選択してください'
        }
      }
    },
    requiredInputFreeText () {
      return {
        isShow: this.selectionTypeId === 2 && (this.interviewer.remarksOrFreeText === null || this.interviewer.remarksOrFreeText.trim().length === 0),
        message: '入力してください'
      }
    },
    overLengthFreeText () {
      return {
        isShow: (this.interviewer.remarksOrFreeText ? this.interviewer.remarksOrFreeText.length > 1000 : false),
        message: '1000文字以内で入力してください'
      }
    }
  }
}
</script>
